/*
const ref_storageValue = document.referrer;
const ref_storageKey = "referrer";

let ref_hasReferrer = "";


if (sessionStorage.getItem(ref_storageKey) !== null) {
  hasReferrer = JSON.parse(sessionStorage.getItem(ref_storageKey));
} else {
  if (ref_hasReferrer.length) {
    const refExists = ref_hasReferrer.toString() === ref_storageValue.toString();
    refExists ??
      sessionStorage.setItem(ref_storageKey, JSON.stringify(ref_storageValue));
  }

  sessionStorage.setItem(ref_storageKey, JSON.stringify(ref_storageValue));
}
*/

// const { search: ref_url } = new URL(window.location.href);

// const ref_params = new URLSearchParams(ref_url);

// const ref_value = {
//   id: `${Date.now()}-${Math.floor(Math.random()*1000)}`,
//   referrer: document.referrer, 
//   urlParams: {
//     utm_source: ref_params?.get('utm_source'), 
//     utm_medium: ref_params?.get("utm_medium"), 
//     utm_campaign: ref_params?.get("utm_campaign")
//   }
// }
// const ref_key = "trackingDetails";

// let ref_exists = "";

// // sessionStorage.setItem(ref_key, JSON.stringify(ref_value))
// if (sessionStorage.getItem(ref_key) !== null) {
//   ref_exists = JSON.parse(sessionStorage.getItem(ref_key));
// } else {
//   sessionStorage.setItem(ref_key, JSON.stringify(ref_value))
// }


// let params = window.location.search;
// if(params){
    
//     let data  = JSON.parse(sessionStorage.getItem("trackingDetails"));
//     let currentRef = window.location.href;
//     data.referrer = currentRef;
//     sessionStorage.setItem("trackingDetails", JSON.stringify(data));
//      $('.jaiTest1').text(sessionStorage.getItem("trackingDetails"));
//     console.log(sessionStorage.getItem("trackingDetails"));
// }

const { search: ref_url, href } = new URL(window.location.href);

const ref_params = new URLSearchParams(ref_url);

// Should give us an object of all url parameters dynamic to the URL
const urlObj = Object.fromEntries(ref_params)
const ref_value = {...urlObj, referrer: document.referrer}
const storage_key = 'trackingDetails';


let ref_exists = "";

if (sessionStorage.getItem(storage_key) !== null) {
  ref_exists = JSON.parse(sessionStorage.getItem(storage_key));
} else {
  sessionStorage.setItem(storage_key, JSON.stringify(ref_value))
  sessionStorage.setItem('urlDetails', JSON.stringify({href, ...ref_value}))
}
